import { createAction, props } from '@ngrx/store';
export const setIsCustomSecurity = createAction('[Import Holdings] Set Is Custom Security', props());
